<template>
  <v-container id="get-pmd">
    <city-header :payload="payload"> </city-header>
    <v-row>
      <textarea id="texto_relatorio" cols="60" rows="15" hidden="false">
        Agora que você respondeu ao diagnóstico ainda existem alguns desafios a serem percorridos.
        Observe o plano de ação e não desanime!
        Vamos tornar o seu município um bom lugar para empreender?
      </textarea>
      <v-col v-if="payload.perguntas.length > 0">
        Plano de Ação - {{ payload.perguntas[0].acompanhamento.nome }} -
        {{
          payload.perguntas[0].acompanhamento.criacao | moment("DD/MM/YYYY")
        }}</v-col
      >
      <v-col class="text-right">
        <v-btn
          v-if="
            isAdmin ||
            isConsultorCondutorMunicipio ||
            isConsultorEspecialistaMunicipio
          "
          outlined
          color="primary"
          class="ml-3"
          @click="update()"
        >
          <span>Atualizar</span>
        </v-btn>

        <v-btn
          v-if="
            isAdmin ||
            isConsultorCondutorMunicipio ||
            isConsultorEspecialistaMunicipio ||
            isAnalista
          "
          outlined
          color="primary"
          class="ml-3"
          @click="createPDF"
        >
          <span>Download PDF</span>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload.perguntas"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          disable-sort
          ref="pmdTable"
        >
          <template v-slot:item.nome="{ item }">
            <a
              :href="
                './#/cidade/' +
                item.municipioId +
                '/acompanhamento/obter/' +
                item.acompanhamentoId
              "
              >{{ item.nome }}</a
            >
          </template>

          <template
            v-slot:item.acoes="{ item }"
            v-if="$store.state.uf === 'RJ'"
          >
            {{ item.pergunta.acao }}
          </template>

          <template v-slot:item.acoes="{ item }" v-else>
            {{ item.pergunta.texto }}
          </template>

          <template v-slot:item.prazo="{ item }">
            <v-text-field
              label="Prazo"
              name="prazo"
              type="text"
              required
              v-model="item.prazo"
            ></v-text-field>

            <v-text-field
              label="Indicador"
              name="indicador"
              type="text"
              required
              v-model="item.indicador"
              v-if="env === 'SC' || env === 'MS'"
            ></v-text-field>
          </template>

          <template v-slot:item.responsavel="{ item }">
            <v-text-field
              label="Responsável"
              name="responsavel"
              type="text"
              required
              v-model="item.responsavel"
            ></v-text-field>

            <v-select
              v-model="item.status"
              item-text="text"
              item-name="value"
              item-value="value"
              :items="status"
              label="Status"
              placeholder="Status"
            >
            </v-select>
          </template>

          <template v-slot:item.meta="{ item }">
            <v-text-field
              label="Meta"
              name="meta"
              type="text"
              required
              v-model="item.meta"
              v-if="env === 'SC' || env === 'MS'"
            ></v-text-field>

            <v-textarea
              label="Observações"
              name="observacoes"
              required
              v-model="item.observacoes"
            ></v-textarea>
          </template>

          <template v-slot:item.pergunta.evidencia="{ item }">
            <app-modal-show-evidence
              :evidence="item.pergunta.evidencia"
              :color="'primary'"
              v-if="item.pergunta.evidencia"
            >
            </app-modal-show-evidence>
          </template>
          <template slot="no-data">
            <span> Nenhuma pergunta retornada </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CityHeader from "@/modules/city/components/Header";
import { pmdAPI } from "../PMDAPI";
import { mapActions, mapGetters } from "vuex";
import JsPDF from "jspdf";
import "jspdf-autotable";

import AppModalShowEvidence from "@/modules/diagnostic/components//ModalShowEvidence";

export default {
  components: {
    CityHeader,
    AppModalShowEvidence,
  },
  data() {
    return {
      headers: [
        { text: "Nº", value: "pergunta.numero" },
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Ação", value: "acoes", width: 300 },
        { text: "Pontos", value: "pergunta.pontos" },
        { text: "", value: "prazo" },
        { text: "", value: "responsavel" },
        { text: "", value: "meta" },
        { text: "Evidência", value: "pergunta.evidencia" },
      ],
      payload: {
        municipioId: this.$route.params.id,
        acompanhamentoId: this.$route.params.acompanhamento,
        perguntas: [],
      },
      status: [
        { text: "Não Iniciada", value: "Não Iniciada" },
        { text: "Em Andamento", value: "Em Andamento" },
        { text: "Atrasada", value: "Atrasada" },
      ],
      env: this.$store.state.uf,
      logo: this.$store.state.logo,
    };
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
    ]),
    listPMD() {
      this.setLoading(true);

      pmdAPI
        .get(this.$route.params.acompanhamento)
        .then((resp) => {
          this.payload.perguntas = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter perguntas");
        });
    },
    update() {
      this.setLoading(true);

      pmdAPI
        .update(this.payload.perguntas)
        .then((resp) => {
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar perguntas");
        });
    },
    createPDF() {
      var source = this.$refs["pmdTable"];
      let rows = [];
      let columnHeader = [];
      if (this.$store.state.uf !== "SC" && this.$store.state.uf !== "MS") {
        columnHeader = [
          "Nº",
          "Tema",
          "Ação",
          "Pontos",
          "Prazo",
          "Responsável",
          "Status",
        ];
      } else {
        columnHeader = [
          "Nº",
          "Tema",
          "Ação",
          "Pontos",
          "Medalha",
          "Prazo",
          "Indicador",
          "Responsável",
          "Status",
          "Meta",
          "Observações",
        ];
      }
      let pdfName =
        "Plano de Ação - " +
        this.payload.perguntas[0].municipio.nome +
        this.payload.perguntas[0].acompanhamento.nome;

      source.items.forEach((element) => {
        var temp = [];
        if (
          this.$store.state.uf !== "SC" &&
          this.$store.state.uf !== "MS" &&
          this.$store.state.uf !== "RJ"
        ) {
          temp = [
            element.pergunta.numero,
            element.pergunta.tema.nome,
            element.pergunta.texto,
            element.pergunta.pontos,
            element.prazo,
            element.responsavel,
            element.status,
          ];
        } else if (this.$store.state.uf === "RJ") {
          temp = [
            element.pergunta.numero,
            element.pergunta.tema.nome,
            element.pergunta.acao,
            element.pergunta.pontos,
            element.prazo,
            element.responsavel,
            element.status,
          ];
        } else {
          temp = [
            element.pergunta.numero,
            element.pergunta.tema.nome,
            element.pergunta.texto,
            element.pergunta.pontos,
            element.pergunta.selo,
            element.prazo,
            element.indicador,
            element.responsavel,
            element.status,
            element.meta,
            element.observacoes,
          ];
        }

        rows.push(temp);
      });

      var logoSebrae = new Image();
      logoSebrae.src = "/assets/img/sebrae_jpeg.jpeg";

      var logoCidade = new Image();
      logoCidade.src = "/assets/img/" + this.$store.state.logo + "_color.png";

      var textoRelatorio = document.getElementById("texto_relatorio");
      var titulo = this.payload.perguntas[0].acompanhamento.nome;

      var doc = new JsPDF("l", "pt");
      doc.setFontSize(16).setFont(undefined, "bold");
      doc.text(250, 45, "Plano de Ação");

      doc.setFontSize(14).setFont(undefined, "normal");
      doc.text(250, 65, titulo);

      doc.setFontSize(13).setFont(undefined, "bold");
      doc.text(250, 85, this.payload.perguntas[0].municipio.nome);
      doc.addImage(logoSebrae, "PNG", 700, 30, 100, 50);
      doc.addImage(logoCidade, "PNG", 40, 30, 0, 50);

      doc.setFontSize(11).setFont(undefined, "normal");
      if (this.$store.state.uf === "BA") {
        doc.text(50, 120, textoRelatorio.value);
      }
      doc.autoTable(columnHeader, rows, {
        startY: 170,
        styles: { overflow: "linebreak", cellWidth: "wrap" },
        columnStyles: {
          text: {
            cellWidth: "auto",
          },
          1: {
            cellWidth: "50",
          },
          2: {
            cellWidth: "50",
          },
          10: {
            cellWidth: "50",
          },
        },
      });
      doc.save(pdfName + ".pdf");
    },
  },
  mounted() {
    this.listPMD();
    this.setConsultorCondutorMunicipio(this.$route.params.id);
    this.setConsultorEspecialistaMunicipio(this.$route.params.id);
    this.setAnalistaMunicipio(this.$route.params.id);
    this.setADMunicipio(this.$route.params.id);

    if (this.$store.state.uf === "SC" || this.$store.state.uf === "MS") {
      this.headers = [
        { text: "Nº", value: "pergunta.numero" },
        { text: "Tema", value: "pergunta.tema.nome" },
        { text: "Ação", value: "pergunta.texto", width: 300 },
        { text: "Pontos", value: "pergunta.pontos" },
        { text: "Medalha", value: "pergunta.selo" },
        { text: "", value: "prazo" },
        { text: "", value: "responsavel" },
        { text: "", value: "meta" },
        { text: "Evidência", value: "pergunta.evidencia" },
      ];
    }
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAnalista",
      "isAuthenticated",
    ]),
  },
};
</script>
